import { useState, useEffect, useCallback} from "react";
import { Container, Form, InputGroup, Button } from "react-bootstrap";
import { Link, useNavigate  } from "react-router-dom"; 

import axios from "axios";
import UploadFiles from "./FileUpload";
import DropBox from "../upload/DropBox";
import Image from "../upload/Image";
import ShowImage from "../upload/ShowImage";

const AddProduct = (props) => {

  let navigate = useNavigate();

  const [validated, setValidated] = useState(false);

  const [name, setName] = useState();
  const [category, setCategory] = useState();
  const [description, setDescription] = useState();
  const [price, setPrice] = useState();
  const [quantity, setQuantity] = useState(1);
  const [reference, setReference] = useState();
  const [isAvailable, setIsAvailable] = useState(true);
  const [media, setMedia] = useState([]);

  const [categories, setCategories] = useState([]);

  const getCategories = useEffect(() => {
    axios({
      method: "get",
      url: "categories/",
      headers: {
        'content-type': 'application/json',
      }
    })
    .then((response) => {
      setCategories(response.data);
    }).catch((error) => {
      // console.log(error);
    })
  }, [])

  //  upload
  const [images, setImages] = useState([]);
  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.map((file, index) => {
      const reader = new FileReader();
      reader.onload = function (e) {
        setImages((prevState) => [
          ...prevState,
          { id: index, src: e.target.result },
        ]);
      };
      reader.readAsDataURL(file);
      return file;
    });
  }, []); 

  const handleSubmit = e => {
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
    }

    e.preventDefault();

    // console.log(media);

    const data = new FormData();
    data.append('name', name);
    data.append('category', category);
    data.append('description', description);
    data.append('price', price);
    data.append('quantity', quantity);
    // data.append('reference', reference);
    data.append('isAvailable', isAvailable);
    data.append('media', media);

    axios({
      method: "post",
      url: "/products",
      data: data,
      headers: {  
        'Content-Type': 'multipart/form-data',
        'Authorization':'Bearer '+ (localStorage.getItem('user')).replace(/"/g, '')
      }
    })
    .then(res => {
      console.log(res.data);
      navigate('/product/index'); 
      window.location.reload();
    })
    .catch(err => {
      // console.log("Une erreur est survenue :" + err)
    })
  }

  return (
    <div>
      <section className="section-pagetop bg">
        <Container>
          <div class="card mx-auto" style={{ maxWidth: '520px'}}>
            <article class="card-body">
              <header class="mb-4">
                <h4 class="card-title">Ajouter un produit</h4>
              </header>
              <Form onSubmit={handleSubmit}>
                <Form.Group>
                  <Form.Label>Nom</Form.Label>
                  <Form.Control type="text" class="form-control" onChange={e => setName(e.target.value)}/>
                </Form.Group>
                <Form.Group>
                  <Form.Label>Catégorie</Form.Label>
                  <Form.Select onChange={e => setCategory(e.target.value)}> 
                  <option>-- sélectionner une catégorie --</option>
                  {categories !== undefined && categories.length > 0 ? 
                    (categories.map((category) => (
                      <option value={category.id}>{category.name}</option>
                    ))) :
                    ''
                  }
                  </Form.Select>
                </Form.Group>
                <Form.Group>
                  <Form.Label>Description</Form.Label>
                  <Form.Control as="textarea" rows={5} class="form-control" onChange={e => setDescription(e.target.value)}/>
                </Form.Group>

                <div class="form-row">
                  <div class="col form-group">
                    <Form.Label>Prix</Form.Label>
                    <InputGroup className="mb-3">
                      <Form.Control type="text" class="form-control" onChange={e => setPrice(e.target.value)}/>
                      <InputGroup.Text>€</InputGroup.Text>
                    </InputGroup>
                  </div>
                  <div class="col form-group">
                    <Form.Label>Quantité</Form.Label>
                      <Form.Control type="text" class="form-control" value={quantity} onChange={e => setQuantity(e.target.value)}/>
                  </div>
                </div>
                <Form.Group className="mb-3">
                  <Form.Check type="checkbox" label="Disponible immédiatement" checked={true} value="true" onChange={e => setIsAvailable(e.target.value)}/>
                </Form.Group>

                  <Form.Label>Images</Form.Label>            
                  {/* <UploadFiles media={media} setMedia={setMedia}/> */}
                  <DropBox onDrop={onDrop} media={media} setMedia={setMedia} images={images}/>
                  <ShowImage images={images} />

                {/* <Form.Group>
                  <Form.Label>Référence</Form.Label>
                  <Form.Control type="text" class="form-control" onChange={e => setReference(e.target.value)}/>
                </Form.Group> */}

                <div class="form-group mt-2">
                  <Button type="submit" class="btn btn-primary btn-block"> Ajouter  </Button>
                </div>              
              </Form>
            </article>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default AddProduct;